<main id="main-content" class="h-screen flex flex-col pl-8 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">
                    {{ pageTitle }}
                </h1>
                <div data-popover-target="popover-bottom" data-popover-placement="bottom" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-bottom" role="tooltip" class="absolute z-10 invisible inline-block w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">

                    <div 
                        *ngIf="currentPageRoute == 'introductory-materials'"
                        class="px-3 py-2"
                    >
                        <p>
                            In the <strong>Document</strong> section, click on each section to highlight and begin filling out the information. For <strong>Promulgation Document</strong> and <strong>Approval Implementation Document</strong>, simply provide the information required in the textbox. When complete, click 
                            <span class="inline-flex px-3.5 py-1 flex items-center justify-center text-white oswald-font bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md">
                                Save
                            </span>. Each of these documents also requires approval. After completion, an authorized administrator should approve the document.
                        </p>
                        <p>
                           <strong>Record of Changes</strong> is a log of all changes that have been made for the current school year. This cannot be edited.
                        </p>
                        <p>
                            In the <strong>Record of Distribution</strong>, users can send a copy of the <strong>Emergency Operations Plan</strong> by email. To do this, click 
                            <span class="inline-flex flex flex-row gap-2 items-center justify-center px-3.5 h-8 rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400  text-white text-sm">  
                                <lucide-icon [name]="icons.Mail" [size]="20"></lucide-icon>
                                Send EOP
                            </span>. In the pop-up, type in the email address of the person for which you would like to send the <strong>Emergency Operations Plan</strong> and click 
                            <span class="inline-flex w-8 h-8 flex flex-row items-center justify-center rounded-md border border-nside-orange-100 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400">
                                <lucide-icon [name]="icons.Plus" [size]="20" class="text-white"></lucide-icon>
                            </span>. If you would like to send the <strong>Emergency Operations Plan</strong> to multiple emails, simply type in an email address and click <span class="inline-flex w-8 h-8 flex flex-row items-center justify-center rounded-md border border-nside-orange-100 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400">
                                <lucide-icon [name]="icons.Plus" [size]="20" class="text-white"></lucide-icon>
                            </span> to add more. Once all emails have been added, click 
                            <span class="inline-flex px-3.5 py-1 flex items-center justify-center text-white oswald-font bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md">
                                Save
                            </span>. Each time an <strong>Emergency Operations Plan</strong> is shared using this functionality, a log will appear. This log will only show records for the current school year.
                        </p>
                    </div>

                    <div 
                        *ngIf="currentPageRoute == 'purpose-situation-overview'"
                        class="px-3 py-2"
                    >
                        <p>
                            In the Document section, click on each section to highlight and begin filling out the information. For each section, simply provide the information required in the textbox. When complete, click 
                            <span class="inline-flex px-3.5 py-1 flex items-center justify-center text-white oswald-font bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md">
                                Save
                            </span>. Each of these documents also requires approval. After completion, an authorized administrator should approve the document.
                        </p>
                    </div>

                    <div 
                        *ngIf="currentPageRoute == 'concept-of-operations' || 
                            currentPageRoute == 'organization-assignment-of-responsibilities' ||
                            currentPageRoute == 'direction-control-coordination' ||
                            currentPageRoute == 'information-collection-analysis-dissemination' ||
                            currentPageRoute == 'administration-finance-logistics' ||
                            currentPageRoute == 'plan-development-maintenance' ||
                            currentPageRoute == 'authorities-references'"
                        class="px-3 py-2"
                    >
                        <p>
                            Complete the textbox. When completed, click on 
                            <span class="inline-flex px-3.5 py-1 flex items-center justify-center text-white oswald-font bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md">
                                Save
                            </span>. This document also requires approval. After completion, an authorized administrator should approve the document.
                        </p>
                    </div>

                    <div 
                        *ngIf="currentPageRoute == 'training-exercises'"
                        class="px-3 py-2"
                    >
                        <p>
                            View the logs below that will be included in your institution's <strong>Emergency Operations Plan</strong>. To make changes to this log, please visit the <strong>Calendar</strong>.
                        </p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
            <eop-assistant
                *ngIf="selectedDoc !== 'Record of Distribution' && currentPageRoute !== 'training-exercises'"
                [sectionId]="sectionTypeId"
                [subSectionId]="subSectionTypeId"
            ></eop-assistant>
        </div>
    </div>
    
    <!-- MAIN CONTENT -->
    <!-- This is for page different than Training & Exercise -->
    <div *ngIf="currentPageRoute != 'training-exercises'" class="p-2 w-full flex flex-grow flex-row items-start gap-8 overflow-y-auto">
        <div *ngIf="documents.length > 0" class="w-1/3 max-h-full bg-white rounded-md shadow-custom-2 p-6 flex flex-col gap-4">
            <div class="flex flex-row w-full items-center justify-between">
                <h2 class="oswald-font text-3xl font-medium">DOCUMENT</h2>
            </div>
            <div class="h-full w-full flex flex-wrap text-gray-900 overflow-y-auto">
                <div class="h-full w-full mr-2 flex flex-col gap-2">
                    <div 
                        class="w-full flex flex-row items-stretch gap-2"
                        *ngFor="let doc of documents"
                    >
                        <button
                            class="min-h-10 flex-1 px-2.5 py-1.5 flex flex-row gap-2 items-center justify-between rounded-md hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 hover:text-white hover:border-nside-orange-100 group"
                            [ngClass]="{
                                'bg-gray-50 border border-nside-gray-300': selectedDoc !== doc,
                                'bg-gradient-to-b from-nside-orange-100 to-nside-orange-200 text-white border-nside-orange-100': selectedDoc === doc
                                }"
                            (click)="$event.preventDefault(); selectDoc(doc);"
                        >
                            <span class="text-start">{{ doc }}</span>
                        </button>
                    </div>
                </div>
            </div>                
        </div>
        <div 
            class="w-full h-full flex flex-col items-center justify-start gap-4"
            [ngClass]="{
                'w-2/3': documents.length > 0
            }"
        >
            <div class="w-full bg-white rounded-md shadow-custom-2 p-6 flex flex-col flex-grow gap-4 overflow-y-auto">

                <!-- TEXTBOX SECTION -->
                <div 
                    *ngIf="(selectedDoc != 'Record of Changes') && (selectedDoc != 'Record of Distribution')" 
                    class="w-full h-full flex flex-col items-center gap-4 overflow-y-auto"
                >
                    <div *ngIf="selectedDoc" class="w-full flex items-center justify-start gap-2">
                        <h2 class="oswald-font text-3xl text-nside-orange-400">
                            {{ selectedDoc }}
                        </h2>        
                    </div>

                    <form
                        class="w-full h-full flex flex-col gap-2"
                        (ngSubmit)="onSubmit()"
                        #promulgationForm="ngForm"
                        >
                        <div class="w-full h-full whitespace-pre-line break-words" *ngIf="!canSave()">{{ description || 'Empty' }}</div>
                            <div class="p-1 w-full flex-grow flex flex-col gap-2">
                            <textarea noEmoji
                                *ngIf="canSave()"
                                name="description"
                                [(ngModel)]="description"
                                rows="10"
                                class="w-full h-full flex-grow bg-gray-50 p-2 text-sm text-gray-900 rounded-md border border-gray-300 resize-none"
                                placeholder="Type here..."
                                required
                            ></textarea>
                        </div>

                        <div class="w-full flex items-center justify-end">
                            <div *ngIf="eopDoc?.last_updated_at" class="w-full flex gap-1 items-start justify-start">
                                <p class="oswald-font font-normal">
                                    Last Updated At: <span class="raleway-font">{{ eopDoc?.last_updated_at | date: 'MM/dd/yyyy - HH:mm' }}</span>
                                </p>
                                <p class="oswald-font font-normal">
                                    By: <span class="raleway-font">{{ eopDoc?.last_updated_user_name || 'None' }}</span>
                                </p>
                            </div>
                            <button
                                *ngIf="canSave()"
                                type="submit"
                                class="w-20 flex items-center justify-center text-white oswald-font px-4 py-1.5 bg-gradient-to-b rounded-md"
                                [ngClass]="{
                                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': !description.trim() || isContentUnchanged,
                                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': description.trim() && !isContentUnchanged
                                }"
                                [disabled]="!description.trim() || isContentUnchanged"
                            >
                                Save
                            </button>
                        </div>
                    </form>

                </div>
                <record-of-changes class="flex-grow overflow-y-auto"
                    *ngIf="selectedDoc === 'Record of Changes'"
                ></record-of-changes>
                <record-of-distribution class="flex-grow overflow-y-auto"
                    *ngIf="selectedDoc === 'Record of Distribution'"
                ></record-of-distribution>
            </div>

            <!-- APPROVE DOCUMENT BUTTON -->
            <div 
                *ngIf="(selectedDoc != 'Record of Changes') && (selectedDoc != 'Record of Distribution')" 
                class="w-full bg-white rounded-md shadow-custom-2 p-6 flex gap-4 overflow-y-auto"
            >
                <div 
                    class="w-full p-2 border-l-4 bg-gray-50 rounded-r-md flex items-end gap-2"
                    [ngClass]="{
                        'border-green-600': eopDoc?.user_name_approved,
                        'border-nside-gray-300': !eopDoc?.user_name_approved
                    }"
                >
                    <div class="w-full flex flex-col items-start justify-between">
                        <p class="oswald-font font-normal">
                            Approved By: <span class="raleway-font">{{ eopDoc?.user_name_approved || 'Not Approved Yet' }}</span>
                        </p>
                        <p class="oswald-font font-normal">
                            Date Approved: <span class="raleway-font">{{ eopDoc?.date_approved | date: 'MM/dd/yyyy - HH:mm' }}</span>
                        </p>
                    </div>
                    <button
                        *ngIf="canSave()"
                        class="w-20 flex items-center justify-center text-white oswald-font px-4 py-1.5 bg-gradient-to-b rounded-md"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': !eopDoc?.description,
                            'border-green-600 from-green-500 to-green-600 hover:from-green-500 hover:to-green-700': eopDoc?.description
                        }"
                        [disabled]="!eopDoc?.description"
                        (click)="$event.preventDefault(); handleApprovePromulgation();">
                        Approve
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- This is for Training & Exercise page -->
    <div *ngIf="currentPageRoute == 'training-exercises'" class="p-2 w-full h-full grow flex flex-row items-start gap-8 overflow-y-auto">
        <div class="bg-white w-full h-full rounded-md shadow-custom-2 p-6 flex flex-col gap-4">
            <training-exercise class="w-full h-full overflow-y-auto"></training-exercise>
        </div>
    </div>

    <prv-next-buttons [totalPages]="(eopNavigationService.totalPages$ | async) || []" />
</main>

<introduction></introduction>

<popup-message 
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>
